export default __webpack_public_path__ + "static/Walls-of-Jerusalem-Christina-Armstrong-064017185a083853fb3a104a128c462c.jpg";